module.exports = __webpack_public_path__ + "img/HZ-T1443B.8da5b28a.jpg";